export interface VideoItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  quality: string;
  views: string;
  rating: string;
  description: string;
  tags: string[];
  releaseDate: string;
}

export const categories = [
  { name: '电影', slug: 'dianying', icon: 'ri-movie-2-line' },
  { name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-2-line' },
  { name: '综艺', slug: 'zongyi', icon: 'ri-emotion-laugh-line' },
  { name: '动漫', slug: 'dongman', icon: 'ri-rocket-line' },
  { name: '纪录片', slug: 'jilupian', icon: 'ri-global-line' },
  { name: '少儿', slug: 'shaoer', icon: 'ri-heart-line' },
];

export const videos: VideoItem[] = [
  {
    id: 'v1',
    title: '流浪地球3：星际远征',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20scene%20with%20astronauts%20and%20giant%20spaceship%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20epic%20scale%2C%20warm%20golden%20and%20deep%20blue%20color%20contrast%2C%20movie%20poster%20aesthetic&width=640&height=360&seq=mogu-video-v1&orientation=landscape',
    duration: '148分钟',
    quality: '1080P',
    views: '1289万',
    rating: '9.3',
    description: '人类文明面临前所未有的危机，太阳急速老化膨胀，将吞没整个太阳系。为了生存，人类联合政府决定启动"流浪地球计划"，在地球表面建造上万座行星发动机，推动地球逃离太阳系，前往4.2光年外的新家园。',
    tags: ['科幻', '冒险', '灾难', '国产大片'],
    releaseDate: '2026-02-10',
  },
  {
    id: 'v2',
    title: '繁华都市：商战风云',
    category: '电视剧',
    categorySlug: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20skyline%20at%20night%20with%20neon%20lights%2C%20luxury%20business%20district%2C%20dramatic%20cinematic%20tone%2C%20warm%20amber%20and%20cool%20teal%20color%20scheme%2C%20TV%20drama%20poster%20style&width=640&height=360&seq=mogu-video-v2&orientation=landscape',
    duration: '45分钟/集',
    quality: '1080P',
    views: '3567万',
    rating: '8.8',
    description: '讲述了改革开放浪潮下，一群年轻人在繁华都市中创业奋斗、商海沉浮的传奇故事。剧中不仅有惊心动魄的商业博弈，更有感人至深的情感纠葛。',
    tags: ['都市', '商战', '情感', '励志'],
    releaseDate: '2026-05-15',
  },
  {
    id: 'v3',
    title: '欢乐喜剧人：爆笑合集',
    category: '综艺',
    categorySlug: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20stage%20with%20spotlights%20and%20confetti%2C%20energetic%20atmosphere%2C%20warm%20lighting%2C%20entertainment%20show%20aesthetic%2C%20Chinese%20variety%20show%20style&width=640&height=360&seq=mogu-video-v3&orientation=landscape',
    duration: '90分钟',
    quality: '1080P',
    views: '5623万',
    rating: '9.1',
    description: '各路喜剧大咖齐聚一堂，带来最爆笑的喜剧表演。相声、小品、脱口秀，各种形式轮番上阵，让你笑到停不下来。',
    tags: ['喜剧', '综艺', '搞笑', '娱乐'],
    releaseDate: '2026-06-20',
  },
  {
    id: 'v4',
    title: '斗罗大陆：神界传说',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20scene%20with%20warrior%20in%20golden%20armor%20standing%20on%20a%20mountain%20peak%2C%20magical%20energy%20surrounding%2C%20dramatic%20clouds%2C%20warm%20sunset%20colors%2C%20Chinese%20animation%20style&width=640&height=360&seq=mogu-video-v4&orientation=landscape',
    duration: '24分钟/集',
    quality: '1080P',
    views: '8921万',
    rating: '9.5',
    content: '唐三带领史莱克七怪踏入神界，面对前所未有的挑战。神界传说篇将揭露斗罗大陆最深层的秘密。',
    tags: ['热血', '奇幻', '战斗', '国漫'],
    releaseDate: '2026-03-01',
  },
  {
    id: 'v5',
    title: '大国重器：探秘深海',
    category: '纪录片',
    categorySlug: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20exploration%20scene%20with%20submarine%20and%20bioluminescent%20creatures%2C%20mysterious%20underwater%20world%2C%20documentary%20cinematography%2C%20cool%20blue%20tones%20with%20warm%20accents&width=640&height=360&seq=mogu-video-v5&orientation=landscape',
    duration: '52分钟',
    quality: '4K',
    views: '2356万',
    rating: '9.6',
    description: '跟随中国深海探测团队，潜入万米深渊，揭开海洋最深处的神秘面纱。从蛟龙号到奋斗者号，见证中国深海科技的辉煌成就。',
    tags: ['科技', '海洋', '探索', '中国制造'],
    releaseDate: '2026-04-22',
  },
  {
    id: 'v6',
    title: '熊熊乐园：快乐冒险',
    category: '少儿',
    categorySlug: 'shaoer',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20bear%20characters%20in%20a%20colorful%20forest%20with%20flowers%20and%20butterflies%2C%20bright%20cheerful%20colors%2C%20children%20animation%20style%2C%20warm%20sunlight&width=640&height=360&seq=mogu-video-v6&orientation=landscape',
    duration: '15分钟/集',
    quality: '1080P',
    views: '4567万',
    rating: '9.2',
    description: '熊熊乐园的小伙伴们又开启新的冒险了！熊大、熊二和他们的朋友们将带你走进一个充满欢乐和惊喜的世界。',
    tags: ['少儿', '动画', '教育', '启蒙'],
    releaseDate: '2026-01-15',
  },
  {
    id: 'v7',
    title: '长安十二时辰：风起云涌',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20dramatic%20atmosphere%2C%20historical%20movie%20aesthetic%2C%20warm%20golden%20light%20against%20dark%20sky&width=640&height=360&seq=mogu-video-v7&orientation=landscape',
    duration: '132分钟',
    quality: '1080P',
    views: '3456万',
    rating: '8.9',
    description: '大唐天宝三年，上元节前夕，长安城陷入了一场惊天阴谋。死囚张小敬临危受命，必须在十二时辰内揪出幕后黑手，拯救长安百万百姓。',
    tags: ['古装', '动作', '悬疑', '历史'],
    releaseDate: '2026-07-08',
  },
  {
    id: 'v8',
    title: '锦绣未央：宫闱深深',
    category: '电视剧',
    categorySlug: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20palace%20interior%20with%20silk%20curtains%20and%20ornate%20furniture%2C%20soft%20warm%20lighting%2C%20historical%20drama%20aesthetic%2C%20romantic%20atmosphere&width=640&height=360&seq=mogu-video-v8&orientation=landscape',
    duration: '45分钟/集',
    quality: '1080P',
    views: '5678万',
    rating: '8.7',
    description: '南北朝时期，一位聪慧勇敢的女子在宫廷中历经磨难，凭借智慧和勇气在权力的漩涡中生存，最终书写了一段不朽传奇。',
    tags: ['古装', '宫廷', '爱情', '权谋'],
    releaseDate: '2026-06-01',
  },
  {
    id: 'v9',
    title: '极限挑战：王者归来',
    category: '综艺',
    categorySlug: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20reality%20show%20scene%20with%20challenging%20obstacle%20course%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20Chinese%20variety%20show%20style&width=640&height=360&seq=mogu-video-v9&orientation=landscape',
    duration: '100分钟',
    quality: '1080P',
    views: '7234万',
    rating: '9.0',
    description: '极限男人帮强势回归！全新一季带来更刺激的挑战、更搞笑的互动。兄弟情深，挑战无限！',
    tags: ['真人秀', '挑战', '搞笑', '户外'],
    releaseDate: '2026-07-15',
  },
  {
    id: 'v10',
    title: '灵笼：末日重生',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20science%20fiction%20anime%20scene%20with%20futuristic%20city%20ruins%2C%20dark%20moody%20atmosphere%2C%20glowing%20elements%2C%20Chinese%203D%20animation%20style&width=640&height=360&seq=mogu-video-v10&orientation=landscape',
    duration: '30分钟/集',
    quality: '1080P',
    views: '6789万',
    rating: '9.4',
    description: '末日废土世界，人类仅存最后的灯塔城。当神秘生物威胁人类生存，一群勇敢的战士挺身而出，为人类命运而战。',
    tags: ['科幻', '末日', '战斗', '国漫'],
    releaseDate: '2026-05-20',
  },
  {
    id: 'v11',
    title: '风味人间：寻味中华',
    category: '纪录片',
    categorySlug: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20photography%20with%20steaming%20dishes%20on%20a%20wooden%20table%2C%20warm%20cozy%20lighting%2C%20rustic%20kitchen%20setting%2C%20documentary%20food%20cinematography&width=640&height=360&seq=mogu-video-v11&orientation=landscape',
    duration: '48分钟',
    quality: '4K',
    views: '4567万',
    rating: '9.7',
    description: '走遍中国大江南北，探寻最地道的美食风味。从街头小吃到宫廷御膳，每一道美食背后都有着动人的故事和独特的文化。',
    tags: ['美食', '文化', '旅行', '人文'],
    releaseDate: '2026-08-01',
  },
  {
    id: 'v12',
    title: '超级飞侠：环球历险',
    category: '少儿',
    categorySlug: 'shaoer',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20airplane%20characters%20flying%20over%20colorful%20world%20map%20with%20landmarks%2C%20bright%20cheerful%20children%20animation%2C%20blue%20sky%20with%20fluffy%20clouds&width=640&height=360&seq=mogu-video-v12&orientation=landscape',
    duration: '12分钟/集',
    quality: '1080P',
    views: '3456万',
    rating: '9.0',
    description: '超级飞侠们踏上环球冒险之旅，每集带你探索一个国家，了解不同的文化和风土人情。寓教于乐，精彩纷呈。',
    tags: ['少儿', '冒险', '教育', '国际'],
    releaseDate: '2026-02-28',
  },
];